<!-- <p >Powered by &nbsp;<a href="https:atai.ai" target="_blank"> atai.ai</a></p> -->
<p class="primary-900 flex center-xs middle-xs">
  <span class="hint-text">
    Powered by &nbsp;
    <a href="https://atai.ai/" target="_blank">
      <img src="assets/images/atai-logo-white_v2.svg" alt="" width="18px"
        style="vertical-align: middle;width:25"></a>&nbsp; All rights reserved. © {{currnet__year}}.
  </span>
</p>
